import React, { Component } from 'react';
import {
  Row,
  Col
} from 'reactstrap';

class ResultsPieChartSVG extends Component {
  render(){
    const { correctVotes, totalVotes } = this.props,
      circumference = 2 * Math.PI * 50,
      percentFull = this.props.correctVotes / this.props.totalVotes,
      angle = percentFull * 2 * Math.PI;

    return (
      <div>
        <svg
          width={this.props.width}
          height={this.props.height}
          viewBox='0 0 100 100'
        >
          <circle
            cx={50}
            cy={50}
            r={50}
            fill='#6482a2'
          />
          <path 
            d={`
              M 50 50 
              L 100 50 
              A 50 50 0 ${+ (percentFull > 0.5)} 0 ${50 + 50 * Math.cos(angle)} ${50 - 50 * Math.sin(angle)}) 
              Z
            `}
            stroke='#1bb255'
            fill='#1bb255'
            strokeWidth={0}
          />
        </svg>
        <div style={{display:'inline-block', verticalAlign:'top', marginLeft:20}}>
          <br />
          <div className='ColorSwatch' style={{backgroundColor:'#1bb255'}} />
          &nbsp;&nbsp;Correct&nbsp;&nbsp;&nbsp;{this.props.correctVotesPercent}%&nbsp;&nbsp;&nbsp;{this.props.correctVotes}
          <br />
          <div className='ColorSwatch' style={{backgroundColor:'#6482a2'}} />
          &nbsp;&nbsp;Incorrect&nbsp;{100 - this.props.correctVotesPercent}%&nbsp;&nbsp;&nbsp;{this.props.totalVotes - this.props.correctVotes}            
        </div>
      </div>
    )
  }
}

ResultsPieChartSVG.defaultProps = {
  width:100,
  height:100,
  correctVotes:40,
  totalVotes:100
}

export default ResultsPieChartSVG;



// WEBPACK FOOTER //
// ./src/shared/components/ResultsPieChartSVG/ResultsPieChartSVG.js